import { Text } from '@/components/ui/text'
import { VStack } from '@/components/ui/vstack'

export default function PrivacyPolicy() {
  return (
    <VStack space="md" className="p-6">
      <Text size="title-2" bold className="text-center">
        金数据客户端隐私政策
      </Text>
      <Text size="footnote" className="text-center text-typography-500">
        (适用于 iOS/Android/小程序)
      </Text>
      <Text className="text-typography-500">【本次更新时间:2025年08月】</Text>

      <Text size="title-3" bold className="mt-4">
        尊敬的客户（在本政策中简称“您”）
      </Text>
      <Text>
        我们十分重视个人信息的保护，我们将通过金数据客户端隐私政策（以下简称“本政策”）帮助您了解我们如何收集、使用、存储及处理您的个人信息以及保障您的个人权利。
      </Text>
      <Text>
        本政策适用于您使用金数据移动端客户端(包含但不限于
        iOS、Android、微信/企业微信/支付宝小程序等)时的个人信息收集与使用场景。如您通过浏览器使用网页版金数据，请参考《金数据隐私政策》。
      </Text>

      <Text size="title-3" bold className="mt-4">
        引言
      </Text>
      <Text>
        「金数据客户端」（本政策中简称“本产品”）是一款由「西安数据如金信息科技有限公司」（在本政策中简称“我们”）自主研发和运营的基于表单的数据收集管理平台金数据的配套客户端产品。请您在使用本产品前，仔细阅读本政策。我们希望通过本政策向您说明在您浏览本产品、注册账号或者在本产品上进行相关活动时，我们如何按照法律法规要求处理这些数据。
      </Text>

      <Text size="title-3" bold className="mt-4">
        定义
      </Text>
      <Text>1. 您，在本政策中主要指我们的用户，即为使用本产品的用户，包含表单创建者、表单发布者和表单填写者。</Text>
      <Text>
        2. 个人信息，是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
      </Text>
      <Text>
        3.
        个人敏感信息，是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。
      </Text>

      <Text size="title-3" bold className="mt-4">
        一、我们收集的数据
      </Text>
      <Text bold>
        1.
        在您首次登录金数据客户端产品前，应先进行账号注册，包括但不限于手机号、邮箱及昵称信息，这是您登录和使用本产品的必要条件。
      </Text>
      <Text bold>
        2.
        若您通过第三方帐号登录、关联本产品的，如微博、微信、QQ、企业微信等，我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，获取并使用您通过第三方授权共享的个人信息如头像、昵称。
      </Text>
      <Text bold>
        3.
        金数据客户端集成了“极验SDK”。当您注册登录时，极验SDK会识别与拦截机器程序进行批量自动化操作，以防止我们的网站和客户端被机器行为攻击。
      </Text>
      <Text bold>
        4.
        金数据客户端集成了“极光推送SDK”，当您登录和使用金数据客户端，极光推送SDK会收集使用实现服务所必须的个人信息，通过加密的通道将消息和通知推送给您。
      </Text>

      <Text size="title-3" bold className="mt-4">
        二、我们如何储存收集的数据
      </Text>
      <Text>
        - 原则上，我们在中华人民共和国境内运营中收集和产生的数据将按照法律法规和国家标准规定
        <Text bold>存储于中国境内，不会向境外转移</Text>。
      </Text>
      <Text>
        - 我们将采用安全措施存储数据，数据的存储期限严格按照法律及相关法规规定，最低期限不少于 6
        个月，并在满足服务目的后的合理期限内予以删除或匿名化处理，除非需要延长保留期或受到法律的允许。
      </Text>

      <Text size="title-3" bold className="mt-4">
        三、我们如何使用收集的数据
      </Text>
      <Text>我们严格遵守法律法规的规定及与您的约定，将收集的信息用于以下用途:</Text>
      <Text>1. 我们会根据本政策的约定并为实现我们的服务或功能对所收集的您的个人信息进行使用；</Text>
      <Text>
        2.
        为了保障服务的稳定性与安全性，我们会将您的信息用于身份验证、安全防范、诈骗监测、预防或禁止非法活动、降低风险、存档和备份用途；
      </Text>
      <Text>3. 根据法律法规或监管要求向相关部门进行报告；</Text>
      <Text>
        4. 当我们展示您的信息时，我们会采用包括内容替换、匿名化处理方式对您的个人信息进行脱敏，以保护您的信息安全。
      </Text>

      <Text size="title-3" bold className="mt-4">
        四、我们如何使用 Cookie 和同类技术
      </Text>
      <Text>
        Cookie
        和同类技术是互联网中的通用常用技术。当您或终端用户使用我们的相关服务时，我们可能会使用相关技术向您的设备发送一个或多个
        Cookie 或匿名标识符，以收集和存储您访问、使用我们网站或系统时的信息。我们使用 Cookie
        和同类技术主要为了保障产品与服务的安全、高效运转，改善产品服务及用户体验。
      </Text>

      <Text size="title-3" bold className="mt-4">
        五、我们高度重视数据安全保障
      </Text>
      <Text>
        数据的安全与合规管理是我们非常重视的工作，我们遵守法律法规的要求，采取较高的行业标准并实施更为高等级的安全及加密策略。我们的信息安全系统已进行国家网络安全等级保护测评(三级)，并建立了完善的数据安全管理体系。
      </Text>

      <Text size="title-3" bold className="mt-4">
        六、您的权利
      </Text>
      <Text>
        1.
        您（作为表单创建者）可在客户端环境内创建表单。您（作为表单填写者）可登录已注册的金数据账号，在“我为他人填写的表单”中查看自己填写的数据。
      </Text>
      <Text>
        2.
        当表单发布者设置了“允许填表人修改数据”相关功能时，您可以根据表单制作者或表单发布者设置的具体功能和提供的修改方式自行修改数据；
      </Text>
      <Text>3. 您需要联系表单发布者来删除自己已经提交的数据；</Text>

      <Text size="title-3" bold className="mt-4">
        七、未成年人信息的保护
      </Text>
      <Text>
        我们非常重视未成年人的个人信息保护。原则上，我们不接受任何未成年人注册成为我们的用户，也不会主动收集未成年人的个人信息。
      </Text>

      <Text size="title-3" bold className="mt-4">
        八、联系我们
      </Text>
      <Text>如果您有任何问题、建议或投诉，请与我们联系，联系方式为电子邮箱「support@jinshuju.net」。</Text>
      <Text>
        我们将尽快审核所涉问题，并在验证您的用户身份后的24小时内予以回复。「西安数据如金信息科技有限公司」对其发布的政策享有版权，受各国版权法及国际版权公约的保护。
      </Text>

      <Text className="text-typography-500 text-center mt-6">
        @{new Date().getFullYear()} Jinshuju, All Rights Reserved, Jinshuju CONFIDENTIAL.
      </Text>
    </VStack>
  )
}
